import { Events } from 'global/constants';

const { events, Ajax } = window.od;

// eslint-disable-next-line import/prefer-default-export
export const subscribeToJSErrors = () => {
	events.subscribe(
		Events.GLOBAL_JS_ERROR_REPORTED,
		({ message, filename, lineno }) =>
			handlePublishEvent({
				message,
				url: filename,
				lineNumber: lineno,
			}),
	);
};

const handlePublishEvent = data => {
	if (shouldCapturePage()) {
		postToServer(data);
	}
};

const shouldCapturePage = () => {
	const { jsErrorsLogToServer, jsErrorsPagesToCapture } = window.od.logging;

	return (
		jsErrorsLogToServer &&
		(jsErrorsPagesToCapture.includes(window.signalData.navigation.pageType) ||
			jsErrorsPagesToCapture.includes('{all}'))
	);
};

const postToServer = data => Ajax.post('/ajax/logjserror', data);
